import React, { useEffect, useRef, useState } from "react";
import images from "../../../../assets/images/constantImages";
import TotalCollection from "./TotalCollection";
import icons from "../../../../assets/images/constantIcons";
import apiService, { formatRupees, handleError } from "../../../Common/ApiCommon/ApiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const TransactionReport = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [transactions, setTransactions] = useState({});
  const menuRef = useRef(null);
  const [selectedFilter, setSelectedFilter] = useState("today");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCustomDateOpen, setIsCustomDateOpen] = useState(false);

  const formatDate = (date) => {
    if (!date) return null;
    return date.toString();
  };

  const openDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const getDateRange = (filter) => {
    const today = new Date();
    let fromDate, toDate;

    if (filter === "today") {
      fromDate = toDate = today;
    } else if (filter === "weekly") {
      fromDate = new Date(today);
      fromDate.setDate(today.getDate() - 7);
      toDate = today;
    } else if (filter === "monthly") {
      fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
      toDate = today;
    }

    return {
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
    };
  };

  // Fetch transactions data
  const fetchDashboardData = async () => {
    try {
      let filterQuery = "";
      let start_date = fromDate;
      let end_date = toDate;

      if (
        selectedFilter === "today" ||
        selectedFilter === "weekly" ||
        selectedFilter === "monthly"
      ) {
        const range = getDateRange(selectedFilter);
        start_date = range.fromDate;
        end_date = range.toDate;
      } else if (selectedFilter === "custom" && fromDate && toDate) {
        start_date = formatDate(fromDate);
        end_date = formatDate(toDate);
      }

      filterQuery = `&filter=${selectedFilter}&start_date=${start_date}&end_date=${end_date}`;
      const response = await apiService.get(`/dashboards?${filterQuery}`);
      setTransactions(response.transactions);
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, [selectedFilter, fromDate, toDate]);

  const handleFilterChange = (filter) => {
    if (filter === "custom") {
      setIsCustomDateOpen((prev) => !prev);
    } else {
      setSelectedFilter(filter.toLowerCase());
      setDropdownOpen(false);
    }
  };

  const applyFilter = () => {
    if (fromDate && toDate) {
      setSelectedFilter("custom");
    }
    setDropdownOpen(false);
    setIsCustomDateOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const transactioncard = [
    {
      background: "bg-blueButton",
      heading: "Net Amount",
      price: formatRupees(transactions.net_balance || 0),
      imageicon: images.netamount,
    },
    {
      background: "bg-blue_500",
      heading: "Discount",
      price: formatRupees(transactions.discount || 0),
      imageicon: images.discount,
    },
    {
      background: "bg-mintcolor",
      heading: "Dues",
      price: formatRupees(transactions.due || 0),
      imageicon: images.duesreport,
    },
    {
      background: "bg-tertiary",
      heading: "Cash",
      price: formatRupees(transactions.cash || 0),
      imageicon: images.cashreport,
    },
    {
      background: "bg-greencardcolor",
      heading: "Card",
      price: formatRupees(transactions.card || 0),
      imageicon: images.cardreport,
    },
    {
      background: "bg-orange",
      heading: "UPI",
      price: formatRupees(transactions.upi || 0),
      imageicon: images.reportupi,
    },
  ];

  return (
    <div className="px-4 py-4">
      <div className="flex justify-between items-center mb-5">
        <h1 className="main_heading text-2xl xl:text-[30px]">Report</h1>
        <div className="relative" ref={menuRef}>
          <button
            onClick={openDropdown}
            className="bg-green700 w-10 h-10 flex items-center justify-center rounded-lg mb-3"
          >
            <img
              src={images.dashboardsetttingicon}
              className="w-5 h-5"
              alt="dashboardsetttingicon"
            />
          </button>

          {dropdownOpen && (
            <div className="absolute right-2 bg-white shadow-md w-[250px] px-4 py-2  z-40 rounded-2xl">
              <div className="flex justify-between items-center border-b py-1 mb-2">
                <p className="text-base font-medium">Filter</p>
                <div
                  className="cursor-pointer"
                  onClick={() => setDropdownOpen(false)}
                >
                  <icons.IoClose className="text-green700" />
                </div>
              </div>
              <div className="flex justify-between items-center px-2 py-2 hover:bg-green50 cursor-pointer text-G500 " onClick={() => handleFilterChange("")}>
                <span className="text-sm">All</span>
              </div>
              {["weekly", "monthly"].map((filter) => (
                <p key={filter}
                  className={`text-sm p-2 rounded-md cursor-pointer hover:bg-green50 ${selectedFilter === filter ? "text-green font-semibold" : " text-G500"
                    }`} onClick={() => handleFilterChange(filter)}>
                  {filter.charAt(0).toUpperCase() + filter.slice(1)}
                </p>
              ))}
              <div
                className={`flex justify-between items-center px-2 py-2 hover:bg-green50 cursor-pointer ${selectedFilter === "custom"
                  ? "text-green font-semibold"
                  : " text-G500"
                  }`}
                onClick={() => handleFilterChange("custom")}
              >
                <span className="text-sm">Custom Date</span>
                <icons.MdOutlineCalendarMonth className="text-green700" />
              </div>
              {isCustomDateOpen && (
                <div className="p-2">
                  <DatePicker
                    selected={fromDate}
                    onChange={setFromDate}
                    selectsStart
                    startDate={fromDate}
                    endDate={toDate}
                    placeholderText="From Date"
                    className="text-G500 placeholder:text-xs border px-3 py-1 rounded w-full mb-2 text-sm outline-none"
                    dateFormat="yyyy-MM-dd"
                  />
                  <DatePicker
                    selected={toDate}
                    onChange={setToDate}
                    selectsEnd
                    startDate={fromDate}
                    endDate={toDate}
                    minDate={fromDate}
                    placeholderText="To Date"
                    className="text-G500 placeholder:text-xs border px-3 py-1 rounded w-full text-sm outline-none"
                    dateFormat="yyyy-MM-dd"
                  />
                  <div className="flex justify-between mt-2">
                    <button
                      className="border border-green hover:bg-green hover:text-white text-green  py-1 rounded-md w-[75px] text-sm text-center"
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setIsDropdownOpen(false);
                        setIsCustomDateOpen(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={applyFilter}
                      className="border border-green text-green hover:bg-green hover:text-white py-1 rounded-md w-[75px] text-sm text-center"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}

              <div
                className="flex justify-between items-center px-2 py-2 hover:bg-green50 cursor-pointer text-G500 "
                onClick={() => handleFilterChange("today")}
              >
                <span className="text-sm">Clear Filters</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5 2xl:gap-10">
        {/* cards */}
        {transactioncard.map((cards, index) => (
          <div
            className={`relative flex items-center justify-between rounded-2xl px-3 s:px-4 py-2 xl:p-4 2xl:px-6 ${cards.background}`}
            key={index}
          >
            {/* card background image */}
            <div className="absolute right-0 bottom-0">
              <img
                src={images.rectangle17}
                alt="rectangle17"
                className="rotate-[-45 deg]"
              />
            </div>
            <div className="absolute top-0 right-0">
              <img
                src={images.rectangle18}
                alt="rectangle18"
                className="rotate-[-0 deg]"
              />
            </div>
            <div className="absolute top-0 right-3">
              <img
                src={images.rectangle19}
                alt="rectangle19"
                className="rotate-[72.7 deg]"
              />
            </div>
            {/* end here */}

            <div className="flex flex-col  text-white">
              <p className="text-sm s:text-lg xl:text-2xl  font-medium mb-1">
                {cards.price}
              </p>
              <h1 className="text-xs s:text-sm 2xl:text-xl">{cards.heading}</h1>
            </div>
            <div className="xl:w-[62px] xl:h-[62px]  sm:w-[52px] sm:h-[52px] md:w-[40px] md:h-[40px] s:w-[40px] s:h-[40px] w-[30px] h-[30px] bg-white flex justify-center items-center rounded-xl">
              <img
                src={cards.imageicon}
                alt="transactionlogo"
                className="xl:w-[45px] xl:h-[45px] sm:w-[45px] sm:h-[45px] md:w-[20px] md:h-[20px] w-[20px] h-[20px]"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransactionReport;
